// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__6TpFy","vLegacy":"SelectSecondary_vLegacy__1Cojc","error":"SelectSecondary_error__1ei6B","disabled":"SelectSecondary_disabled__1Tjwg"};